<template>
  <div class="home">
    <l-map
      ref="myMap"
      id="map"
      :zoom.sync="zoom"
      :center="center"
      :bounds="bounds"
    >
      <l-tile-layer
        key="osm.street"
        name="OpenStreetMap"
        :bounds="bounds"
        :visible="true"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
        layer-type="base"/>
      
      <l-marker
        v-for="marker in latestMarkers"
        :key="marker.id"
        :visible="true"
        :draggable="false"
        :lat-lng="marker.position"
        :icon="marker.icon == 'red' ? redMarkerIcon : markerIcon">
        <l-popup :content="marker.tooltip" />
        <l-tooltip :content="marker.tooltip" />
      </l-marker>

      <l-polyline
        v-for="path in $store.state.queryLastResultPaths"
        :lat-lngs="path"
        color="green">
      </l-polyline>

      <l-marker
        v-for="marker in $store.state.queryLastResultPathsMarkers"
        :key="marker.id"
        :visible="true"
        :draggable="false"
        :lat-lng="marker.position"
        :icon="marker.icon == 'path-stop' ? pathStopMarkerIcon : pathStartMarkerIcon">
        <l-tooltip :content="marker.tooltip" />
      </l-marker>
    </l-map>
  </div>
</template>

<style lang="scss">
  #map {
    height: 100%;
    width: 100%;
  }

  .home {
    height: 100%;
    width: 100%;
  }

  .device-id {
    font-family: monospace;
  }
</style>

<script>
import L from 'leaflet'
import {LMap, LTileLayer, LMarker, LTooltip, LPopup, LPolyline} from 'vue2-leaflet'

import { mapState } from 'vuex'

import config from '@/config'
import { timestampToReadable } from '@/utils'

export default {
  name: 'home',

  beforeCreate () {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },

  data () {
    const markerIcon = L.icon({
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconAnchor: [13, 41],
      iconSize: [25, 41]
    })

    const redMarkerIcon = L.icon({
      iconUrl: require('../assets/red-marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
      iconRetinaUrl: require('../assets/red-marker-icon-2x.png'),
      iconAnchor: [13, 41],
      iconSize: [25, 41]
    })

    const pathStartMarkerIcon = L.icon({
      iconUrl: require('../assets/path-start-marker-2x.png'),
      iconRetinaUrl: require('../assets/path-start-marker-2x.png'),
      iconAnchor: [12, 12],
      iconSize: [25, 25]
    })

    const pathStopMarkerIcon = L.icon({
      iconUrl: require('../assets/path-stop-marker-2x.png'),
      iconRetinaUrl: require('../assets/path-stop-marker-2x.png'),
      iconAnchor: [12, 12],
      iconSize: [25, 25]
    })

    return {
      center: [42.545767, 14.535378],
      zoom: 6,
      bounds: null,
      markerIcon: markerIcon,
      redMarkerIcon: redMarkerIcon,
      pathStartMarkerIcon: pathStartMarkerIcon,
      pathStopMarkerIcon: pathStopMarkerIcon,
      latestMarkers: []
    }
  },

  components: {
    LMap, LTileLayer, LMarker, LTooltip, LPopup, LPolyline
  },

  computed: mapState(['queryLastResultPaths', 'queryLastResultPathsMarkers']),

  created () {
    this.updateLatest()

    this.interval = setInterval(this.updateLatest, config.LIVE_UPDATE_INTERVAL)

    window.viewGraphFor = this.viewGraphFor.bind(this)
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  watch: {
    queryLastResultPaths () {
      this.updateLatest()
    }
  },

  methods: {
    updateLatest () {
      console.log('updating latest positions...')

      this.$http.get(config.API_URL + '/latest', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        (response) => {
          if (response.body == null) {
            this.latestMarkers = []
          } else {
            this.latestMarkers = response.body.rows.map((record) => {
              let text = ''

              text += '<b>' + record[3] + '</b><br>'
              text += '<span class="device-id">' + record[2].substr(0, 12) + '</span><br>'
              text += record[4] + ', ' + record[5] + '<br>'
              text += timestampToReadable(record[1]) + '<br>'
              if (record[6] == true) {
                text += '<b>[posizione non aggiornata]</b><br>'
              }

              text += '<p>'
              for (var i = 7; i < response.body.columns.length; i++) {
                if (record[i] != null) {
                  const column = response.body.columns[i]

                  let value = record[i]

                  if (column.type == "number" && column.multiplier != null && column.multiplier != 0) {
                    const decimals = Math.max(Math.log10(1 / column.multiplier), 0)
                    value = record[i].toFixed(decimals)
                  }
                  
                  text += '<u>' + column.label + '</u>: ' + value + '<br>'
                }
              }
              text += '</p>'

              text += '<p>'
              text += '<a href="javascript:viewGraphFor(\'' + record[2] + '\');">Vista grafico</a>'
              text += '</p>'

              var icon = 'default'
              if (record[6] == true) {
                icon = 'red'
              }

              return {
                id: record[2],
                device_label: record[3],
                position: {
                  lat: record[4],
                  lon: record[5]
                },
                tooltip: text,
                icon: icon
              }
            })
          }
        }, (err) => {
          console.log(err)
          this.$store.commit('LOGOUT_USER')
          localStorage.removeItem('token')
          this.$router.push('/login')
        }
      )
    },

    viewGraphFor (deviceID) {
      this.$store.commit('SET_CURRENT_GRAPH_DEVICE', deviceID)
      this.$router.push('/graphview')
    }
  }
}
</script>
